import { isDefined } from "@clipboard-health/util-ts";
/* eslint-disable-next-line no-restricted-imports */
import { getFirebaseSingleton } from "@src/lib/firebase/src";

import { getAuthHeaderProvider } from "./authHeaderProviderRef";

/**
 * Retrieves the formatted authentication value for the Authorization header.
 *
 * Returns the appropriate format based on authentication provider:
 * - **Cognito** (both flags enabled): `Bearer <token>` (OAuth 2.0 standard)
 * - **Firebase** (fallback): `<token>` (legacy format)
 *
 * @param forceRefresh - If true, forces token refresh from the auth provider
 * @returns The formatted authorization header value, or undefined if unavailable
 *
 * @example
 * ```ts
 * const authHeaderValue = await getAuthHeaderValue();
 * headers: { Authorization: authHeaderValue }
 * ```
 */
export async function getAuthHeaderValue(forceRefresh?: boolean): Promise<string | undefined> {
  const authHeaderProvider = getAuthHeaderProvider();

  if (isDefined(authHeaderProvider)) {
    return await authHeaderProvider(forceRefresh);
  }

  // Fallback when provider not initialized (legacy format without Bearer prefix)
  return await getFirebaseSingleton().currentUser?.getIdToken(forceRefresh);
}
